<po-page-default p-title="Relatório de Empresas x Certidões" [p-breadcrumb]="breadcrumb">
  <div class="po-row">
    <div class="po-row">
      <po-container class="po-lg-12 po-md-12 po-sm-12">
        <span class="po-lg-12 po-md-12 po-sm-12 po-mb-2 po-font-text-uppercase">
          <span class="an an-file-text"></span>
          Empresas e emissão de certidões
        </span>

        <div class="po-lg-11 po-md-9 po-sm-8 po-mb-5 destaque">
          <p class="po-font-text-large po-mb-1">Nesta etapa o sistema tentará realizar as seguintes
            operações:
          </p>
          <p><b> &nbsp;&nbsp; - Localizar as empresas conforme a certidão selecionada.</b></p>
          <p><b> &nbsp;&nbsp; - Gerar o arquivo em CSV e o ZIP dos documentos.</b></p>
        </div>

        <po-select class="po-lg-3" p-label="Certidão" p-placeholder="Selecione uma certidão..." [p-show-required]="true"
          [p-required]="true" (p-change)="onChangeTipocertidao($event)" [p-options]="[
                  {
                    label: 'Trabalhista',
                    value: 'CND-TRABALHISTA'
                  },
                  {
                    label: 'Divida Ativa SP',
                    value: 'CND-DT-SP'
                  },
                  {
                    label: 'Divida Ativa (Não Inscritos) SP',
                    value: 'CND-DTNI-SP'
                  },
                  {
                    label: 'FGTS',
                    value: 'CND-FGTS'
                  },
                  {
                    label: 'Municipal',
                    value: 'CND-MUNICI'
                  }
                  ]" p-help="Informe uma certidão válida." p-required="true" p-name="certidaoSelect">
        </po-select>
        <po-select class="po-lg-3" p-label="Competência" p-placeholder="Selecione uma competencia."
          [p-show-required]="true" [p-required]="true" (p-change)="onChangeCompetencia($event)"
          [p-options]="competenciaOptions" p-help="Informe uma competência válida." p-required="true"
          p-name="competenciaSelect">
        </po-select>
        <po-combo class="po-lg-3" p-label="Cidade" p-placeholder="Selecione uma cidade..."
          [p-show-required]="true" [p-required]="true" (p-change)="onChangeCidade($event)"
          [p-options]="cidadesOptions" p-help="Informe uma cidade válida." p-name="cidadeSelect">
        </po-combo>
        <po-button class="po-lg-3 po-mt-4" p-label="Gerar Relatório" (p-click)="geraReportEmpresaCertidao()"
          [p-loading]="loading"></po-button>
        <div class="po-lg-12 po-md-9 po-sm-8">
          <po-radio-group class="po-lg-12 po-mt-4" [(ngModel)]="tipoFiltro" [p-show-required]="true" [p-required]="true"
            name="radioGroupCertidoes" p-label="Filtrar por" [p-columns]="4" [p-options]="[
                { label: 'Com Emissão', value: '0' },
                { label: 'Sem Emissão', value: '1' },
                { label: 'Erro de Emissão', value: '2' },
                { label: 'Todas', value: '3' }
              ]">
          </po-radio-group>
        </div>
      </po-container>
    </div>
  </div>
</po-page-default>
